<script>
  import calculate from '@mixins/calculate'
  import modal from '@mixins/modal'
  import { mapState } from 'vuex'
  export default {
    mixins: [calculate, modal],
    props: {
      moduleKey: {
        type: String,
        required: true
      },
      areaKey: {
        type: String,
        required: false
      },
      isDisabled: {
        type: Boolean,
        required: false,
        default: false
      },
      maxReachedTrigger: {
        type: Boolean,
        required: false,
      },
    },
    template: '#template_modulkonfigurator_checkbox',
    data () {
      return {
        uid: null,
        selectedInOther: null
      }
    },
    computed: {
      // ...mapGetters(['getModuleById']),
      getModule () {
        return this.$store.getters['getModuleById']
      },
      ...mapState(['form']),
      module () {
        const self = this
        let module = self.form.allModules.find((module) => {
          return module.id === self.moduleKey
        })
        return module
      },
      maxReachedAndIsNotSelected () {
        return this.maxReachedTrigger && !this.selected
      },
      maxReachedAndIsSelectedAndNotADisabledModule () {
        return this.maxReachedTrigger && this.selected && !this.module.disabled
      },
      selected: {
        get () {
          const self = this
          return self.module.selected
        },
        set (payload) {
          const self = this
          const form = Object.assign({}, self.form)

          let moduleIndex = form.allModules.findIndex((module) => {
            return module.id === self.moduleKey
          })
          if (moduleIndex > -1) {
            form.allModules[moduleIndex].selected = payload
            self.calculateForm(form).then((form) => {
              self.$store.dispatch('setForm', form)
            })
          }
        }
      },
      key () {
        return this.module.key
      },
      moduleContent () {
        return this.getModule(this.module.key)
      },
      label () {
        const self = this
        let content = self.moduleContent
        if (content) {
          return content.name + ' (' + content.key + ')'
        }
        return self.module.label
      },
      disabled () {
        return this.module.disabled || this.isDisabled || this.otherSelected
      },
      otherSelected () {
        let selectedInOther = this.selectedInOther
        return (selectedInOther && selectedInOther.selected === true)
      },
      required () {
        return this.module.required
      },
      visible () {
        let result = true
        if (this.module.hidden === true) {
          result = false
        }

        return result
      }
    },
    methods: {
      calculateSelectInOther () {
        const self = this
        self.selectedInOther = self.form.allModules.find((module) => {
          return module.id === this.module.selectInOther
        })
      },
      showModal () {
        this.showInfoModal({
          title: 'Informationen',
          text: this.moduleContent.description
        })
      }
    },
    mounted () {
      this.uid = this._uid
    },
    watch: {
      // form (newVal) {
      form () {
        this.calculateSelectInOther()
      }
    }
  }
</script>
